import React ,{useState}  from 'react';
import './Navidentification.css';

// import LocalMallIcon from '@material-ui/icons/LocalMall';

// import ModalSignIn from '../Modal/Modal'

// import Dropi18N from '../DropI18N/DropI18N'

import { useTranslation} from 'react-i18next';
import i18next from '../../i18n';
import flagEnglish from '../../assets/flagEnglish.png'
import flagDubai from '../../assets/flagDubai.svg'
import flagRusse from '../../assets/drapeauRusse.svg'
import logoFr from '../../assets/drapeauFr.png'
import drapeauCoreen from '../../assets/drapeauCoreen.jpg'

const useChangeFlag = () => {

    const [ContainerLangue, setContainerLangue] = useState( <img width="25px"  style={{paddingTop: '0px', }} src={logoFr} alt="logo France" /> )  
        
    const English = () => setContainerLangue( <img width="36px" style={{ marginRight: '5px' }} src={flagEnglish} alt="logo Angleterre" /> )  

    const Dubai = () => setContainerLangue( <img width="36px" style={{ marginRight: '5px' }} src={flagDubai} alt="logo Italy" />)  

    const Russe = () => setContainerLangue( <img width="36px" style={{ marginRight: '5px' }} src={flagRusse} alt="drapeau Russe" />)  

    const Coreen = () => setContainerLangue( <img width="36px" style={{ marginRight: '5px' }} src={drapeauCoreen} alt="drapeau Coreen" />)  

    const French = () => setContainerLangue( <img width="25px"  style={{paddingTop: '0px', }} src={logoFr} alt="logo France" />)  
    
    return [ContainerLangue, English , French, Coreen, Russe, Dubai ]

}


const NavIdentification = () => {
    useTranslation();
    // const { t } = useTranslation();
    function handleClick(lang) {
        i18next.changeLanguage(lang)
    }
    const [  English , French, Coreen, Russe, Dubai] = useChangeFlag()

    return (
        <div className="container-fluid d-none d-sm-block bg-light border p-1">
            <div className="row  justify-content-md-center ">

                <div className="col-md-6  text-dark bg-light container d-none d-sm-block"> 	
                    {/* <Dropi18N /> */}
                    <div className="row">
                        <div className=" col" type="button" onClick={()=>{
                            handleClick('fr');
                            French();
                            }} >
                                <img width="35px" style={{ marginRight: '5px'  }} src={logoFr} alt="logo France" />Français 
                        </div>

                        <div className=" col" type="button" onClick={()=>{
                            handleClick('eng');
                            English();
                            }} >
                                <img width="36px" style={{ marginRight: '5px' }} src={flagEnglish} alt="logo Angleterre" />English
                        </div>

                        <div className="col" type="button" onClick={()=>{
                            handleClick('ara');
                            Dubai();
                            }} >
                                <img width="36px" style={{ marginRight: '5px' }} src={flagDubai} alt="logo dubai" />alearabia
                        </div>

                        <div className="col" type="button" onClick={()=>{
                            handleClick('ru');
                            Russe();
                            }} >
                                <img width="36px" className="border" style={{ marginRight: '5px' }} src={flagRusse} alt="drapeau Russe" />русски 
                        </div>

                        <div className="col" type="button" onClick={()=>{
                            handleClick('ko');
                            Coreen();
                            }} >
                                <img width="36px" style={{ marginRight: '5px' }} src={drapeauCoreen} alt="drapeau Coreen" />한국어
                        </div>
                    </div>

                </div>
                

                {/* <div className="col-md-3  text-dark bg-light border ">
                    {t('NavIdentification.ServiceClient')} 
                </div>

                <div className="col-md-3 text-dark bg-light border">
                    <ModalSignIn />
                </div>

                <div className="col-md-3 text-dark bg-light">
                    <LocalMallIcon  style={{ color: "#8d010e" }} />
                   
                </div> */}

            </div>
            
        </div>
    )
}

export default NavIdentification



